export const phoneCasesEndPoints = {
  getList: (queryString: string) => `/phoneCases/list${queryString}`,
  create: () => '/phoneCases/create',
  update: (id: string) => `/phoneCases/update/${id}`,
  getById: (id: string) => `/phoneCases/getById/${id}`,
  delete: (id: string) => `/phoneCases/delete/${id}`,
  toggleActive: (id: string) => `/phoneCases/activate/${id}`,
};
